module.exports = __webpack_public_path__ + "img/20190902151526143.f4daed4f.jpg";